/**
 * FG Magnit — accessible tabs (WAI-ARIA tabs pattern, manual activation).
 * Click, Enter or Space selects a tab; ←/→, Home and End move between tabs.
 * Panels are found through each tab's aria-controls, so they may live
 * anywhere in the section.
 */
class FgTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    if (this.tabs.length === 0) return;
    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i, false));
      tab.addEventListener('keydown', (event) => this.onKey(event, i));
    });
  }

  panel(tab) {
    return document.getElementById(tab.getAttribute('aria-controls'));
  }

  select(index, focus) {
    this.tabs.forEach((tab, i) => {
      const on = i === index;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      const panel = this.panel(tab);
      if (panel) panel.hidden = !on;
    });
    if (focus) this.tabs[index].focus();
    // Keep the chosen tab visible when the tab row scrolls on phones.
    this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }

  onKey(event, index) {
    const last = this.tabs.length - 1;
    let next = null;
    if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
    if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = last;
    if (next === null) return;
    event.preventDefault();
    this.select(next, true);
  }
}

if (!customElements.get('fg-tabs')) {
  customElements.define('fg-tabs', FgTabs);
}
